import { createFileRoute } from '@tanstack/react-router';

import { assertUuidRouteParams } from '../../../lib/assert-uuid-route-params.js';
import { WorkOrderDetailPage } from '../../../modules/manufacturing/work-order-detail-page.js';

export const Route = createFileRoute('/manufacturing/work-orders/$workOrderId')({
  beforeLoad: ({ params }) => assertUuidRouteParams(params),
  component: WorkOrderDetailRoute,
});

// eslint-disable-next-line react-refresh/only-export-components
function WorkOrderDetailRoute() {
  const { workOrderId } = Route.useParams();
  return <WorkOrderDetailPage workOrderId={workOrderId} />;
}
